









import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';

export default mixins(LocationBasedMixin).extend({
    components: {
        RevenueTypes: () => import('./RevenueTypes.vue'),
        Taxes: () => import('./Taxes.vue'),
    },
    data() {
        return {
            i18nPrefix: 'admin.revenue',
        };
    },
});
